/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./PremiumReportList.module.css";

interface CreditUnionInfoProps {
  creditUnionNumber: string;
}

const CreditUnionInfo: React.FC<CreditUnionInfoProps> = ({
  creditUnionNumber,
}) => {
  return (
    <div className={styles.creditUnionInfo}>
      {creditUnionNumber} Credit Union
    </div>
  );
};

export default CreditUnionInfo;
